var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignalAntennaC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7CFE2"
    },
    d: "M370.641,500.671L264.492,137.997c-1.106-3.77-4.561-6.362-8.492-6.362 c-3.931,0-7.386,2.592-8.492,6.362L141.36,500.671c-1.063,3.641,0.311,7.559,3.421,9.736c3.127,2.173,7.265,2.116,10.323-0.134 L256,435.848l100.896,74.424c1.563,1.149,3.403,1.728,5.252,1.728c1.771,0,3.542-0.531,5.071-1.593 C370.329,508.229,371.703,504.312,370.641,500.671z M300.09,322.601l-29.18-21.502l18.826-13.872L300.09,322.601z M256,171.972 l28.446,97.182L256,290.114l-28.444-20.96L256,171.972z M222.265,287.227l18.826,13.872l-29.18,21.502L222.265,287.227z  M165.712,480.466l26.77-91.468l48.617,35.858L165.712,480.466z M197.769,370.919l5.943-20.303l52.289-38.53l52.289,38.53 l5.943,20.303L256,413.868L197.769,370.919z M270.902,424.856l48.617-35.858l26.77,91.468L270.902,424.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3A8A5"
    },
    d: "M256,131.636c-3.931,0-7.386,2.592-8.492,6.362l-32.177,109.939 c5.479,2.075,11.109,3.839,16.952,5.064l23.716-81.028l23.716,81.028c5.843-1.225,11.473-2.989,16.952-5.064L264.49,137.998 C263.387,134.227,259.931,131.636,256,131.636z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8269"
    },
    d: "M205.958,199.08c-2.263,0-4.527-0.864-6.254-2.592c-31.037-31.037-31.037-81.546,0-112.584 c3.455-3.455,9.054-3.455,12.508,0c3.455,3.455,3.455,9.052,0,12.508c-24.144,24.144-24.144,63.423,0,87.567 c3.455,3.455,3.455,9.052,0,12.508C210.485,198.215,208.221,199.08,205.958,199.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8269"
    },
    d: "M306.043,199.08c-2.263,0-4.527-0.864-6.254-2.592c-3.455-3.455-3.455-9.052,0-12.508 c24.144-24.144,24.144-63.423,0-87.567c-3.455-3.455-3.455-9.052,0-12.508s9.054-3.455,12.509,0 c31.037,31.037,31.037,81.546,0,112.584C310.57,198.215,308.306,199.08,306.043,199.08z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF91"
    },
    d: "M343.567,236.609c-2.263,0-4.527-0.864-6.254-2.592c-3.455-3.451-3.455-9.052,0-12.508 c32.575-32.584,42.579-81.283,25.475-124.069c-1.814-4.536,0.397-9.684,4.933-11.497c4.527-1.788,9.684,0.389,11.497,4.933 c19.73,49.363,8.189,105.548-29.396,143.142C348.094,235.745,345.831,236.609,343.567,236.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF91"
    },
    d: "M353.303,72.406c-2.617,0-5.209-1.153-6.954-3.365c-2.79-3.542-5.83-6.958-9.036-10.155 c-3.455-3.451-3.455-9.052-0.009-12.508c3.455-3.464,9.061-3.455,12.517-0.009c3.689,3.689,7.196,7.627,10.418,11.709 c3.023,3.836,2.367,9.399-1.468,12.426C357.148,71.785,355.22,72.406,353.303,72.406z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD2BE"
    },
    d: "M124.645,280.393c-2.263,0-4.527-0.864-6.254-2.592c-75.871-75.88-75.871-199.334,0-275.21 c3.455-3.455,9.052-3.455,12.508,0c3.455,3.455,3.455,9.052,0,12.508c-68.969,68.978-68.969,181.212,0,250.193 c3.455,3.455,3.455,9.054,0,12.508C129.172,279.528,126.909,280.393,124.645,280.393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD2BE"
    },
    d: "M387.356,280.393c-2.263,0-4.527-0.864-6.254-2.592c-3.455-3.455-3.455-9.052,0-12.508 c68.969-68.982,68.969-181.215,0-250.193c-3.455-3.455-3.455-9.052,0-12.508s9.052-3.455,12.508,0 c75.871,75.875,75.871,199.33,0,275.21C391.882,279.528,389.619,280.393,387.356,280.393z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF91"
    },
    d: "M140.997,195.081c-3.507,0-6.833-2.107-8.215-5.567c-19.73-49.363-8.189-105.548,29.396-143.138 c3.455-3.455,9.054-3.455,12.509,0c3.455,3.455,3.455,9.052,0,12.508c-32.575,32.58-42.579,81.279-25.475,124.064 c1.814,4.536-0.397,9.684-4.933,11.497C143.201,194.873,142.095,195.081,140.997,195.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF91"
    },
    d: "M168.434,236.609c-2.263,0-4.527-0.864-6.254-2.587c-3.671-3.671-7.178-7.611-10.418-11.705 c-3.023-3.836-2.375-9.399,1.46-12.426c3.845-3.027,9.39-2.367,12.43,1.455c2.807,3.559,5.848,6.976,9.036,10.159 c3.455,3.451,3.455,9.052,0.009,12.508C172.968,235.745,170.697,236.609,168.434,236.609z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8269"
    },
    d: "M256,131.636c-3.931,0-7.386,2.592-8.492,6.362l-17.202,58.771c5.304,2.426,11.005,4.105,16.986,4.95 L256,171.973l8.706,29.746c5.981-0.845,11.681-2.524,16.986-4.95l-17.202-58.771C263.387,134.227,259.931,131.636,256,131.636z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF5050"
    },
    cx: 256.006,
    cy: 140.48,
    r: 26.537
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalAntennaC);
export default __webpack_public_path__ + "static/media/signal_antenna_c.cf27206f40c02f18cdad18e2b2ea4e17.svg";
export { ForwardRef as ReactComponent };